/*
* @Author: Karen Yunuen Pozos Arias
* @JobTitle: Full Stack Developer - IBL
* @Email: kpozos@ibl.mx
*/

import React from 'react';  // Importing React library to use JSX syntax
import { Typography } from '@mui/material';  // Importing Typography component from Material UI for text styling
import CustomMiniCard from "../../../../../components/CustomMiniCard";  // Importing a custom component for displaying a mini card
import { CustomCheckbox } from "../../../../../components/CustomCheckbox";  // Importing custom checkbox component
import { useTranslation } from "react-i18next";  // Importing the useTranslation hook for internationalization (i18n)


// The functional component to render employee notification cards
const EmployeeNotificationCard = ({ checkboxId, item, handleCheckBox, selectedEmployees }) => {
    const { t } = useTranslation();  // Accessing translation function for multi-language support

    return (
        // CustomMiniCard component to display employee details in a card format
        <CustomMiniCard
            showButton={true}  // Controls whether the button is displayed inside the card
            ButtonIcon={
                // CustomCheckbox component for displaying a checkbox with a change handler
                <CustomCheckbox
                    id={checkboxId}  // Unique ID for each checkbox
                    trans={""}  // Placeholder for translation if needed
                    checked={selectedEmployees?.includes(item.id)}  // Checks if the employee is in the selected list
                    onChange={(e) => handleCheckBox(e, item)}  // Calls handleCheckBox function when the checkbox state changes
                />
            }
        >
            {/* Typography for displaying the employee's name */}
            <Typography className='title' component='div'>
                <span>{t('name').toLocaleUpperCase()}: </span>
                {item?.name.toLocaleUpperCase()}  {/* Display employee's name */}
            </Typography>

            {/* Typography for displaying the employee's phone number */}
            <Typography className='availability no-transform-margin'>
                <span>{t('phoneNumber').toLocaleUpperCase()}: </span>
                {item?.phoneNumber}  {/* Display employee's phone number */}
            </Typography>

            {/* Typography for displaying the employee's email */}
            <Typography className='description no-transform-margin' variant='body2'>
                <span>{t('email').toLocaleUpperCase()}: </span>
                {item?.email}  {/* Display employee's email */}
            </Typography>
        </CustomMiniCard>
    );
};

export default EmployeeNotificationCard;  // Export the component for use in other parts of the app
